module.exports = __webpack_public_path__ + "static/media/utm_avobold_italic.ad22f3c5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/Assets/Fonts/utm_avobold_italic.woff
// module id = 376
// module chunks = 7